import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../../app/store";
import { getBackendUrl, LoadStateInfo, loaded, loading, notStarted, error, failedResponse } from "../common";
import { getToken } from "../../features/user/UserAvatar";
import { imageSetAvatarThunk } from "../image/imageSetAvatar";
import { ObjectTarget } from "../../app/permissions";

export interface RoutineItemState {
  state: LoadStateInfo;
  selected?: RoutineItemInfo;
}

const initialState: RoutineItemState = {
  state: notStarted(),
};


export interface RetrieveRoutineItemRequest {
  routineItemId: string;
}

export const retrieveRoutineItem = createAsyncThunk(
  "retrieveRoutineItem",
  async (param: RetrieveRoutineItemRequest, thunkAPI) => {
    console.debug("retrieve routine item");

    const response = await fetch(`${getBackendUrl()}/api/routine-item/${param.routineItemId}`, {
      signal: thunkAPI.signal,
      headers: {
        "Authorization": `Bearer ${getToken()}`,
      }
    });

    if(response.ok) {
      return await response.json();
    } else {
      return thunkAPI.rejectWithValue(failedResponse( response ));
    }
  }
);


export const routineItemSlice = createSlice({
  name: "routineItem",
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
    select: (state, action: PayloadAction<RoutineItemInfo | undefined>) => {
      console.trace(`select :: ${action.payload?.name}`);
      state.selected = action.payload;
    },
    clean: (state) => {
      state.state = notStarted();
      state.selected = undefined;
    }
  },
  // The `extraReducers` field lets the slice handle actions defined elsewhere,
  // including actions generated by createAsyncThunk or in other slices.
  extraReducers: (builder) => {
    builder
      .addCase(retrieveRoutineItem.pending, (state, /* action */) => {
        state.state =  loading();
        state.selected = undefined;
      })
      .addCase(retrieveRoutineItem.fulfilled, (state, action) => {
        console.debug(`${action.type}`);
        state.state =  loaded();
        state.selected = action.payload;
      })
      .addCase(retrieveRoutineItem.rejected, (state, action) => {
        state.state = error(action);
      })
      .addCase(imageSetAvatarThunk.fulfilled, (state, action) => {
        if(state.selected
          && action.meta.arg.objectTarget == ObjectTarget.ROUTINE_ITEM
          && action.meta.arg.targetId == state.selected?.id
        ) {
          state.selected.url = action.payload;
        }
      });
    },
});

export interface RoutineItemInfo {
  id: string;
  routineId: string;
  name: string;
  url?: string;
  order?: number;
}

// export const { } = routineItemSlice.actions;

export const selectRoutineItem = (state: RootState) => state.routineItem;

export default routineItemSlice.reducer;
